import { render } from "./UserReportsTable.vue?vue&type=template&id=0ddce99c"
import script from "./UserReportsTable.vue?vue&type=script&lang=js"
export * from "./UserReportsTable.vue?vue&type=script&lang=js"

import "./UserReportsTable.vue?vue&type=style&index=0&id=0ddce99c&lang=less"

import exportComponent from "/Users/kacper/IdeaProjects/e.on-portal-awarie/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__